"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";

import { captureActivity } from "@/lib/activity-client";

export function ActivityTracker() {
  const pathname = usePathname();

  useEffect(() => {
    if (!pathname) return;
    captureActivity({
      eventType: "page.view",
      route: pathname,
      referrer: document.referrer || undefined,
    });
  }, [pathname]);

  return null;
}
